import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import o from "./Collection.js";
import { HandleOwnerMixin as s } from "./HandleOwner.js";
import { isSome as e, isNone as r } from "./maybe.js";
import "./accessorSupport/watch.js";
import { autorun as i } from "./accessorSupport/trackingUtils.js";
import { property as n } from "./accessorSupport/decorators/property.js";
import "./arrayUtils.js";
import "./has.js";
import "./accessorSupport/ensureType.js";
import { subclass as c } from "./accessorSupport/decorators/subclass.js";

var l = /*#__PURE__*/function (_s) {
  _inherits(l, _s);

  var _super = _createSuper(l);

  function l(t) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, t), _this.getCollections = null;
    return _this;
  }

  _createClass(l, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.handles.add(i(function () {
        return _this2.refresh();
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.getCollections = null;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var t = e(this.getCollections) ? this.getCollections() : null;
      if (r(t)) return void this.removeAll();
      var o = 0;

      var _iterator = _createForOfIteratorHelper(t),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _s2 = _step.value;
          e(_s2) && (o = this._processCollection(o, _s2));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.splice(o, this.length);
    }
  }, {
    key: "_createNewInstance",
    value: function _createNewInstance(t) {
      return new o(t);
    }
  }, {
    key: "_processCollection",
    value: function _processCollection(t, o) {
      if (!o) return t;
      var s = this.itemFilterFunction ? this.itemFilterFunction : function (t) {
        return !!t;
      };

      var _iterator2 = _createForOfIteratorHelper(o),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _e = _step2.value;

          if (_e) {
            if (s(_e)) {
              var _o = this.indexOf(_e, t);

              _o >= 0 ? _o !== t && this.reorder(_e, t) : this.add(_e, t), ++t;
            }

            if (this.getChildrenFunction) {
              var _o2 = this.getChildrenFunction(_e);

              if (Array.isArray(_o2)) {
                var _iterator3 = _createForOfIteratorHelper(_o2),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var _s3 = _step3.value;
                    t = this._processCollection(t, _s3);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              } else t = this._processCollection(t, _o2);
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return t;
    }
  }]);

  return l;
}(s(o));

t([n()], l.prototype, "getCollections", void 0), t([n()], l.prototype, "getChildrenFunction", void 0), t([n()], l.prototype, "itemFilterFunction", void 0), l = t([c("esri.core.CollectionFlattener")], l);
var p = l;
export { p as default };